<template>
  <div id="partners" class="partners partners_inner __animated">
    <div class="partners__container">
      <div class="partners__inside">
        <div class="container">
            <div class="partner-container__liner">
                <div class="title partners__title">
                    <h2>
                        <span>{{ pageH1 }}</span>
                    </h2>
                </div>
                <div class="partners__button-block"> 
                    <button class="button button-black" @click="callModal('marketplace')">
                            Купить на маркетплейсах
                    </button>
                </div>
            </div>
        </div>

        <div class="container">
          <div class="container__liner">
            <div class="partners__option_info"> - Авторизованные пункты замены масла (АПЗМ)</div>
          </div>
        </div>
        <div class="partners__content">
          <div id="mapForm">

            <div class="partners__sidebar" v-show="showMobileTab('Partners')">
              <div class="partners__list">
                <div class="mCustomScrollBox">

                  <div v-if="loading" class="loader">
                    <div class="loader-map">
                      <div class="loader-map-box box-flex">
                        <div class="load-skeleton item item-bg"></div>
                        <div class="load-skeleton item item-md"></div>
                        <div class="load-skeleton item item-md"></div>
                        <div class="load-skeleton item item-md"></div>
                      </div>
                      <div class="loader-map-box box-flex">
                        <div class="load-skeleton item item-bg"></div>
                        <div class="load-skeleton item item-md"></div>
                        <div class="load-skeleton item item-md"></div>
                        <div class="load-skeleton item item-md"></div>
                      </div>
                      <div class="loader-map-box box-flex">
                        <div class="load-skeleton item item-bg"></div>
                        <div class="load-skeleton item item-md"></div>
                        <div class="load-skeleton item item-md"></div>
                        <div class="load-skeleton item item-md"></div>
                      </div>
                    </div>
                  </div>

                  <div v-else class="mCSB_container">
                    <div
                        class="locations__point"
                        v-for="(partner, index) in partners"
                        :key="index"
                        :class="{ 'locations__point_active': partner.coords === selectedMarker }"
                        @click="selectPartner(partner.coords)"
                    >
                      <div class="locations__header" v-if="partner.signboard" :class="{ 'locations__header_auth': partner.is_authorised }">{{ partner.signboard }}</div>
                      <div class="locations__header" v-else :class="{ 'locations__header_auth': partner.is_authorised }">Автомагазин</div>
                      <div class="locations__address">{{partner.address}}</div>

                      <div v-if="partner.working_time" class="locations__row" style="display: block">
                        Часы работы:
                        <div class="working-time">
                          <div class="working-time__status">
                            {{ workingTimeStatus(partner.working_time_array, partner.utc) }}
                          </div>
                          <div
                            class="working-time__message"
                            :class="{ 'is_active': showListWorkingTime === index }"
                            @click.stop="toggleWorkingTimeList(index)"
                            v-clickoutside="clickOutside"
                          >
                            <span>{{ workingTimeMessage(partner.working_time_array, partner.utc) }}</span>
                            <div class="working-time__list" :class="{'is-active' : showListWorkingTime === index}">
                              <div
                                v-for="(item, ii) in partner.working_time_array"
                                :key="ii"
                                class="working-time__item"
                                :class="{'working-time_active' : dayCurrent == item.day }"
                              >
                                <span>{{ item.day }}</span> {{ item.start ? item.start : 'выходной' }}  {{ item.end ? '- ' + item.end : '' }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="locations__phone">
                        <a v-for="(phone, index) in partner.phone" :key="index" :href="`tel:${phone}`">{{phone}}</a>
                      </div>
                      <div class="locations__url">
                        <a v-for="(url, index) in partner.url" :key="index" :href="url">{{url}}</a>
                      </div>
                      <div class="locations__email">
                        <a v-for="(email, index) in partner.email" :key="index" :href="`mailto:${email}`">{{email}}</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="partners__ui">
              <div
                class="partners__cities"
                v-click-outside="switchDropOut"
              >
                <select class="searchable" v-show="false"></select>
                <div class="chosen-container chosen-container-single" style="width: 311px;">
                  <a v-if="currentCity"
                    class="chosen-single"
                    @click="displayDropOut=!displayDropOut"
                  >
                    <input class="chosen-focus-input" type="text" autocomplete="off" id="city">
                    <label for="city">{{currentCity.name}}</label>
                    <div class="select-arrow"><b></b></div>
                  </a>
                  <div
                    class="chosen-drop"
                    v-show="displayDropOut"
                  >
                    <div class="chosen-search">
                      <input
                        class="chosen-search-input"
                        type="text"
                        autocomplete="off"
                        data-index="cities"
                        @keyup="insertedSearchFilter($event, 'cities')"
                        @keypress.enter="autoInsertedSearchFilter($event)"
                        id = 'input-def'
                      >
                    </div>
                    <ul class="chosen-results">
                      <li
                        class="active-result"
                        v-for="(city, index) in cities"
                        :key="index"
                        v-show="showBySearch('cities', city)"
                        @click="onChange($event, city)"
                      >{{city.name}}</li>
                    </ul>
                  </div>
                </div>
              </div>
              <label class="double">
                <input type="checkbox" class="double__ui" @change="changePoints('exchange')">
                <span class="double__left"> Купить </span>
                <span class="double__indicator"></span>
                <span class="double__right"> Купить и заменить </span>
              </label>
              <label class="double">
                <input type="checkbox" class="double__ui" @change="changeType">
                <span class="double__left"> Масла </span>
                <span class="double__indicator"></span>
                <span class="double__right"> Антифриз/ТЖ </span>
              </label>
              <!-- <label class="custom-ui">
                <input
                    type="checkbox"
                    class="custom-ui__input"
                    @change="changePoints('authorized')"
                    :disabled="!exchange"
                    :checked="authorized"
                >
                <span class="custom-ui__presence"></span>
                <span class="custom-ui__text">Показать авторизированные центры</span>
              </label> -->
              <div class="partners__tab">
                <button
                  class="partners__button"
                  :class="{ 'partners__button-active': mobileTab === 'Map' }"
                  @click="mobileTab = 'Map'"
                >Карта</button>
                <button
                  class="partners__button"
                  :class="{ 'partners__button-active': mobileTab === 'Partners' }"
                  @click="mobileTab = 'Partners'"
                >Партнеры</button>
              </div>
            </div>
          </div>
          <div class="partners__map" v-show="showMobileTab('Map')">
            <yandex-map
                v-if="coords"
                :settings="settings"
                :coords="coords"
                :zoom="mapZoom"
                :controls="controls"
                ref="ymap"
                @map-was-initialized="onMapInitialized"
            >
              <ymap-marker
                v-for="(partner, index) in mapPartners"
                :key="partner.id || index"
                :marker-id="partner.id || index"
                :coords="partner.coords"
                :icon="selectedMarker === partner.coords ? (partner.is_authorised ? selectedMarkerIconAuth : selectedMarkerIcon) : (partner.is_authorised ? markerIconAuth : markerIcon)"

                :hint-content="partner.signboard"
                :balloon-template="partner.balloon"

                @click="selectPartner(partner.coords)"
              ></ymap-marker>
                <!--
                  :icon="selectedMarker === partner.coords ? selectedMarkerIcon : markerIcon"
                  
                  :hint-content="partners.signboard || partners.address"
                :balloon-template="partners.balloon" -->
            </yandex-map>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import { yandexMap, ymapMarker } from 'vue-yandex-maps'
import { fetchWhereToBuy } from '../api/adminBrands'

export default {
  name: 'widget-map',
  components: { yandexMap, ymapMarker },
  data() {
    return {
      mobileTab: 'Map',
      loading: false,
      api_cities: 'cities',
      api_points: 'points',
      type: 'tcl-oil',
      zoom: 12,
      mapZoom: 12,
      pendingCityMapView: null,
      yandexMapInstance: null,
      selectedMarker: null,
      selectedPartner: null,
      selectedSearch: [],
      partners: [],
      authorized: false,
      exchange: false,
      displayDropOut: false,
      currentCity: null,
      cities: null,
      controls: ['zoomControl', 'typeSelector'],
      coords: [43.123156, 131.909521],
      settings: {
        apiKey: process.env.VUE_APP_YANDEX_API_KEY,
        lang: 'ru_RU',
        coordorder: 'latlong',
        enterprise: false,
        version: '2.1',
      },
      markerIcon: {
        layout: 'default#image',
        imageHref: '/img/pin-ghost.svg',
        imageSize: [55, 73],
        imageOffset: [-27.5, -73],
      },
      markerIconAuth: {
        layout: 'default#image',
        imageHref: '/img/pin-ghost-auth.svg',
        imageSize: [55, 73],
        imageOffset: [-27.5, -73],
      },
      selectedMarkerIcon: {
        layout: 'default#image',
        imageHref: '/img/pin.svg',
        imageSize: [116, 155],
        imageOffset: [-58, -155],
      },
      selectedMarkerIconAuth: {
        layout: 'default#image',
        imageHref: '/img/pin-auth.svg',
        imageSize: [116, 155],
        imageOffset: [-58, -155],
      },
      showListWorkingTime: null,
    }
  },
  computed: {
    pageH1() {
      const s = this.$store.state.seoPage
      if (s && s.id && s.h1) {
        return s.h1
      }
      return 'Где купить/заменить продукцию TCL?'
    },
    dayCurrent() {
      const days = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];
      const date = new Date();
      return days[date.getDay()];
    },
    timeCurrent() {
      return this.$moment(new Date()).format('H:mm');
    },
    detectRobot() {
      // eslint-disable-next-line
      const robots = new RegExp([
        /bot/, /spider/, /crawl/,
        /APIs-Google/, /AdsBot/, /Googlebot/, /Googlebot-Mobile/,
        /mediapartners/, /Google Favicon/, /Googlebot-Image/,
        /FeedFetcher/, /Google-Read-Aloud/,
        /DuplexWeb-Google/, /googleweblight/,
        /bing/, /yandex/, /baidu/, /duckduck/, /yahoo/,
        /ecosia/, /ia_archiver/,
        /facebook/, /instagram/, /pinterest/, /reddit/,
        /slack/, /twitter/, /whatsapp/, /youtube/,
        /semrush/,
      ].map((r) => r.source).join('|'), 'i');

      return robots.test(navigator.userAgent);
    },
    mapPartners() {
      return (this.partners || []).filter((partner) => this.normalizeCoords(partner && partner.coords))
    },
    storeCities () {
      return this.$store.state.cities
    },
    selectCity () {
      return this.$store.state.select_city
    }
  },
  watch: {
    storeCities(value) {
      this.cities = value
    },
    selectCity(value) {
      this.currentCity = value
      this.getPoints(value.id)
    },
  },
  methods: {
    timeToDate(time) {
      const chunks = time.split(':');
      const date = new Date();

      date.setHours(Number(chunks[0]));
      date.setMinutes(Number(chunks[1]));

      return date;
    },
    workingTimeStatus(dateArray, utc) {
      const dateCurrent = dateArray.find((date) => this.dayCurrent === date.day);
      const now = new Date();

      const curOffset = (new Date().getTimezoneOffset() / 60) * -1;
      now.setHours(now.getHours() - ((+curOffset) - (+utc)));

      if (dateCurrent && dateCurrent.start && dateCurrent.end) {
        const dateStart = this.timeToDate(dateCurrent.start);
        const dateEnd = this.timeToDate(dateCurrent.end);

        if (now >= dateStart && now <= dateEnd) return 'Открыто';
      }
      return 'Закрыто';
    },
    workingTimeMessage(dateArray, utc) {
      const dateCurrent = dateArray.find((date) => this.dayCurrent === date.day);
      const now = new Date();
      const curOffset = (new Date().getTimezoneOffset() / 60) * -1;
      now.setHours(now.getHours() - ((+curOffset) - (+utc)));

      if (dateCurrent) {
        if (dateCurrent.start) {
          if (now < this.timeToDate(dateCurrent.start)) return `Откроется в ${dateCurrent.start}`;
        }

        if (!dateCurrent.end || now > this.timeToDate(dateCurrent.end)) {
          let dateOpen = null;
          let idx = dateArray.indexOf(dateCurrent);
          let count = 0;
          while (dateOpen === null || count === 7) {
            if (idx + 1 === dateArray.length) idx = 0;
            else idx += 1;

            dateOpen = dateArray[idx].start ? dateArray[idx].start : null;
            count += 1;
          }
          return `Откроется в ${dateOpen}`;
        }

        return `Закроется в ${dateCurrent.end}`;
      }

      return 'Не работает';
    },
    setBlockTime() {
      const blockTime = new Date();
      blockTime.setDate(blockTime.getDate() + 4);
      localStorage.setItem('blockTime', +blockTime);
    },
    toggleWorkingTimeList(index) {
      this.showListWorkingTime = this.showListWorkingTime === index ? null : index;
    },
    clickOutside() {
      this.showListWorkingTime = null;
    },
    callModal(param) {
        //console.log("Opening modal with param:", param)
        this.$store.commit('SET_MODAL_NAME_ENABLED', param)
    },
    showMobileTab(tab) {
      if (window.screen.width <= 767) {
        if (tab === this.mobileTab) return true
      } else return true
      return false
    },
    changePoints(param) {
      if (this.currentCity) {
        if (param === 'exchange') {
          this.authorized = false
          this.exchange = !this.exchange
        }
        if (param === 'authorized') this.authorized = !this.authorized
        this.getPoints(this.currentCity.id)
      }
    },
    async changeType() {
      if (this.type === 'tcl-oil') this.type = 'tcl'
      else this.type = 'tcl-oil'
      await this.getCities()
      await this.getPoints(this.currentCity.id)
    },
    switchDropOut() {
      this.displayDropOut = false
    },
    autoInsertedSearchFilter(event) {
      const parent = event.target.closest('.chosen-drop')
      const list = parent.lastChild.querySelectorAll('.active-result')
      const BreakException = {}
      try {
        list.forEach((item) => {
          const text = item.innerText.toLowerCase()
          if (text.includes(event.target.value.toLowerCase())) {
            item.click()
            throw BreakException
          }
        });
      } catch (e) {
        if (e !== BreakException) throw e
      }
    },
    selectPartner(coords) {
      this.mobileTab = 'Map'
      this.selectedMarker = coords
      this.setMapCenter(coords, 15)
    },
    insertedSearchFilter(event, name) {
      this.selectedSearch[name] = event.target.value
      //delete this.SelectedFilters[name];
      this.$forceUpdate();
    },
    showBySearch(name, value) {
      const search = this.selectedSearch[name]
      if (!search || search.length < 1) return true
      return (value.name && value.name.toLowerCase().includes(search.toLowerCase()))
    },
    onChange(event, city) {
      this.displayDropOut = false
      this.currentCity = city
      this.getPoints(city.id)
    },
    async getCities() {
      const response = await fetchWhereToBuy(`${this.api_cities}/${this.type}`)

      if (Array.isArray(response)) {
        this.cities = response
      }
    },
    async getPoints(city_id) {
      this.loading = true
      const query = []

      if (this.exchange) query.push('segment=3') //СТО
      if (this.authorized) query.push('is_authorised=true')

      const suffix = query.length ? `?${query.join('&')}` : ''
      const response = await fetchWhereToBuy(`${this.api_points}/${this.type}/${city_id}${suffix}`)
      if (!Array.isArray(response)) {
        this.partners = []
        this.loading = false
        return
      }

      let temp = response
      for (let i = 0; i < response.length; i += 1) {
        const point = temp[i]
        const address = point.address
        if (!point.coords) {
          if (address && typeof address === 'object') {
            point.coords = [address.latitude, address.longitude]
            point.address = address.name
          } else if (point.latitude != null && point.longitude != null) {
            point.coords = [point.latitude, point.longitude]
          }
          const { icon } = point
          delete point.icon
          point.icon = { content: icon }
        }
        if (address && typeof address === 'object') {
          point.address = address.name
        }
        point.coords = this.normalizeCoords(point.coords)
          || this.normalizeCoords([point.latitude, point.longitude])
      }

      this.partners = temp
      this.applyCityMapView(temp)
      setTimeout(() => this.loading = false, 450);
    },
    normalizeCoords(coords) {
      if (!Array.isArray(coords) || coords.length < 2) return null
      const lat = Number(coords[0])
      const lon = Number(coords[1])
      if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null
      if (lat === 0 && lon === 0) return null
      if (Math.abs(lat) > 90 || Math.abs(lon) > 180) return null
      return [lat, lon]
    },
    percentile(sorted, p) {
      const index = (sorted.length - 1) * p
      const lower = Math.floor(index)
      const upper = Math.ceil(index)
      if (lower === upper) return sorted[lower]
      return sorted[lower] + (sorted[upper] - sorted[lower]) * (index - lower)
    },
    median(values) {
      const sorted = [...values].sort((a, b) => a - b)
      const mid = Math.floor(sorted.length / 2)
      return sorted.length % 2 ? sorted[mid] : (sorted[mid - 1] + sorted[mid]) / 2
    },
    computeCityMapView(cityPoints, defaultZoom = 12, padding = 0.7) {
      const coords = (cityPoints || [])
        .map((point) => this.normalizeCoords(point && point.coords))
        .filter(Boolean)
      if (!coords.length) return null

      const lats = coords.map((item) => item[0])
      const lons = coords.map((item) => item[1])
      const sortedLats = [...lats].sort((a, b) => a - b)
      const sortedLons = [...lons].sort((a, b) => a - b)

      const centerLat = this.median(lats)
      const centerLon = this.median(lons)
      const minLat = this.percentile(sortedLats, 0.05)
      const maxLat = this.percentile(sortedLats, 0.95)
      const minLon = this.percentile(sortedLons, 0.05)
      const maxLon = this.percentile(sortedLons, 0.95)

      let zoom = defaultZoom
      if (coords.length === 1) {
        zoom = 12
      } else {
        const latSpan = Math.max(maxLat - minLat, 0.005)
        const lonSpan = Math.max(maxLon - minLon, 0.003)
        const latZoom = Math.log2(360 / (latSpan * padding))
        const lonZoom = Math.log2(360 / (lonSpan * padding))
        zoom = Math.floor(Math.min(latZoom, lonZoom))
        zoom = Math.min(14, Math.max(11, zoom))
      }

      return {
        coords: [centerLat, centerLon],
        zoom,
      }
    },
    applyMapViewport(map, view) {
      if (!map || !view) return false
      const { coords, zoom } = view
      if (typeof map.setCenter === 'function') {
        map.setCenter(coords, zoom)
        return true
      }
      if (typeof map.setZoom === 'function') {
        map.setZoom(zoom)
      }
      if (typeof map.panTo === 'function') {
        map.panTo(coords, { flying: true })
      }
      return true
    },
    getYandexMap() {
      const map = this.$refs.ymap
      return this.yandexMapInstance || (map && (map.myMap || map.ymap))
    },
    onMapInitialized(map) {
      this.yandexMapInstance = map
      if (this.pendingCityMapView) {
        this.applyMapViewport(map, this.pendingCityMapView)
        this.pendingCityMapView = null
      }
    },
    syncCityMapView(view) {
      if (!view) return
      this.mapZoom = view.zoom
      this.zoom = view.zoom
      this.coords = view.coords
      this.$nextTick(() => {
        if (this.applyMapViewport(this.getYandexMap(), view)) {
          this.pendingCityMapView = null
          return
        }
        this.pendingCityMapView = view
      })
    },
    applyCityMapView(cityPoints) {
      this.syncCityMapView(this.computeCityMapView(cityPoints, 12, 0.7))
    },
    setMapCenter(coords, zoom) {
      const center = this.normalizeCoords(coords)
      if (!center) return
      const nextZoom = Number.isFinite(zoom) ? zoom : this.mapZoom
      this.mapZoom = nextZoom
      this.zoom = nextZoom
      this.coords = center
      this.$nextTick(() => {
        const map = this.getYandexMap()
        if (!map) return
        if (typeof map.setCenter === 'function') {
          map.setCenter(center, nextZoom)
        } else if (typeof map.panTo === 'function') {
          map.panTo(center, { checkZoomRange: true })
        }
      })
    },
  },
  directives: {
    ClickOutside
  },
  created() {
    if (this.storeCities) {
      this.cities= this.storeCities
    }
    
    if (this.selectCity) {
      this.currentCity = this.selectCity
      this.getPoints(this.selectCity.id)
    }

    const lsLocation = this.$localStorage.get('LOCATION')

    if (lsLocation) {
      const local = JSON.parse(lsLocation)
      this.coords = [local.lat, local.lon]
    } else {
      this.coords = [55.4507, 37.3656]
    }
  }
}
</script>